class MegaMenu extends HTMLElement {
  constructor() {
    super();
    var menuItems = this.querySelectorAll('[data-index]');
    var subMenus = this.querySelectorAll('[data-sub-menu]');
    var page = document.getElementById('main');
    var header = document.getElementById('navbar-desktop');

    menuItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
        setTimeout(this.revealHeader(item, subMenus, menuItems), 200);
      })
    })
    subMenus.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        var dataFlag = item.getAttribute('data-main'); 
        var menuItem = document.querySelector('[data-index="' + dataFlag + '"]'); 
      })
      item.addEventListener('mouseleave', () => {
        this.closeMenus(menuItems, subMenus);
      })
    })
    header.addEventListener('mouseenter', () => {
      this.closeMenus(menuItems, subMenus);
    })
    page.addEventListener('mouseenter', () => {
      this.closeMenus(menuItems, subMenus);
    })

  }

  revealHeader(item, subMenus, menuItems) {
    this.closeMenus(menuItems, subMenus);
    if(item.matches(':hover')){
      var selector = item.getAttribute('data-index');
      var menuToOpen = document.querySelector('[data-sub-' + selector + ']');
      menuToOpen.classList.remove('d-none');
      item.querySelector('svg').classList.remove('d-none');
    }
  }

  closeMenus(menuItems, subMenus) {
    menuItems.forEach((item) => {
      item.classList.add('text-white');
      item.querySelector('svg').classList.add('d-none');
    })
    subMenus.forEach((item) => {
      item.classList.add('d-none');
    })
  }
}

customElements.define('mega-menu', MegaMenu);